import '@angular/compiler';
import {COMPILER_OPTIONS, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IconBoxModule} from './modules/icon-box/icon-box.module';
import {HtmlAnchorDirective} from './directives/html-anchor.directive';
import {ContentShieldDirective} from '@shared/modules/content/directives/content-shield.directive';
import {DocumentService} from './services/document/document.service';
import {DocumentKeyEventService} from './services/key-event/key-event.service';
import {DocumentResourceLinkService} from './services/resource/link.service';
import {AssignmentAnswersStateService} from './services/show-answers/answers-state.service';
import {DocumentReferenceService} from './services/reference/reference.service';
import {JitComponentFactory} from './factories/jit-component.factory';
import {AutoCheckService} from './services/autocheck/auto-check.service';
import {ContentComponent} from './content.component';
import {MathJaxModule} from 'ngx-mathjax';
import {DocumentSourceFactory} from '@shared/modules/content/modules/factories/source.factory';

@NgModule({
    jit: true,
    declarations: [
        ContentComponent,
        HtmlAnchorDirective,
        ContentShieldDirective,
    ],
    exports: [
        ContentComponent,
    ],
    providers: [
        {
            provide: COMPILER_OPTIONS,
            useValue: {},
            multi: true,
        },
        DocumentService,
        DocumentKeyEventService,
        DocumentResourceLinkService,
        AssignmentAnswersStateService,
        DocumentReferenceService,
        DocumentSourceFactory,
        JitComponentFactory,
        AutoCheckService,
    ],
    imports: [
        MathJaxModule.forRoot({
            version: '2.7.7',
            config: 'TeX-AMS-MML_HTMLorMML',
            hostname: 'cdnjs.cloudflare.com',
        }),
        CommonModule,
        IconBoxModule,
    ],
})
export class ContentModule {
}
